module.exports = __webpack_public_path__ + "media/6.cf71f950.wav";